var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1048",
    "data-name": "Group 1048",
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.582,
    height: 26.767,
    viewBox: "0 0 107.582 26.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(40.407 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Download_on",
    "data-name": "Download on",
    transform: "translate(0 9)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Montserrat-Regular, Montserrat",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Get it on")), /*#__PURE__*/React.createElement("text", {
    id: "play",
    transform: "translate(0.175 23.767)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Play Store")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M1.1,25.036h0A1.888,1.888,0,0,1,0,23.324V1.715A1.89,1.89,0,0,1,1.108,0l12.93,12.516L1.1,25.035Zm2.9-.651h0l11.147-10.79,2.988,2.892-14.134,7.9ZM19.554,15.7h0l-3.286-3.181,3.284-3.179L22.536,11a1.869,1.869,0,0,1,.022,3.014l-3,1.679Zm-4.4-4.26h0L4.011.652,18.139,8.547l-2.985,2.889Z",
    transform: "translate(0 1.126)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.3eade99e4855c82a36adb5446330e357.svg";
export { ForwardRef as ReactComponent };